import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { FACILITY_ACCOUNT_FIELDS } from "constants/form-fields";
import { SUPPLY_CHAIN_COLS } from "constants/table-columns";
import { Table } from "components/table"; 
import {
    Form,
    Card,
    Button, 
} from "antd";
import { List } from "immutable";
import moment from "moment";
// import FacilityAccountService from "services/facility-account-service";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
// import CompanyService from "services/company-service";
// import _lower from "lodash/toLower";
import ConfirmationActionModal from "../components/confirmation-action-modal";
const FormItem = Form.Item;
// const Option = Select.Option;
class AccountFacilityForm extends React.Component {
    state = {
        selectedLedgers: [],
        schemesList: [],
        filteredSchemeList: [],
        confirmationModalShow : false,
        schemeSelectedDetails : []
    };
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    FORM_FIELDS = FACILITY_ACCOUNT_FIELDS({
        validator: (rules, value, callback) => {
            callback();
        }
    });

    // componentDidMount() {
    //     this.props.supplyChains && this.props.supplyChains.map(_ => {
    //         FacilityAccountService.SchemeDetailsList(this.props.bankId, _.seller.id).then(__ => {
    //             this.setState({
    //                 schemesList: __.data,
    //                 filteredSchemeList: __.data,
    //             });
    //             this.schemeDataNew[_.seller.id] = __.data;
    //         }).catch((error) => {
    //             console.error(error.message);
    //         });
    //     });
    // }

    schemeDataNew = {};

    // componentDidUpdate(prevProps) {
    //     if(this.props.supplyChains !== prevProps.supplyChains){
    //         this.props.supplyChains.map(_ => {
    //             FacilityAccountService.SchemeDetailsList(this.props.bankId, _.seller.id).then(__ => {
    //                 this.schemeDataNew[_.seller.id] = __.data;
    //                 this.setState({
    //                     schemesList: __.data,
    //                     filteredSchemeList: __.data,
    //                 });
    //             }).catch((error) => {
    //                 console.error(error.message);
    //             });
    //         });
    //     }
    // }

    handleFormSubmit = (submitEvent) => {
        submitEvent.preventDefault();
        const {selectedSchemes} = this;

        this.setState({
            confirmationModalShow : true,
            schemeSelectedDetails : this.props.supplyChains.map(_ => _.set("scheme_name",this.schemeDataNew[_.seller.id].find(__ => __.id ===  (selectedSchemes[_.id])) ?this.schemeDataNew[_.seller.id].find(__ => __.id ===  (selectedSchemes[_.id])).name :  ""))
        });
        
    };

    onFilter = (val) => {
        this.setState({
            selectedLedgers: this.state.selectedLedgers.push(val)
        });
    };

    // onSearchVal = (str) => {
    //     this.setState({
    //         filteredSchemeList: this.state.schemesList.filter(_ => {
    //             return _.name && _.name.toLowerCase().includes(str && str.toLowerCase());
    //         })
    //     }, () => this.getData());
    // }

    selectedSchemes = {};

    // updateSchemeData = (id, value, losschemeid) => {
    //     if(this.state.selectedSchemes) {
    //         this.selectedSchemes = {
    //             ...this.state.selectedSchemes,
    //             [id]: value,
    //             los_company_scheme_id: losschemeid
    //         };    
    //     }
    //     else {
    //         this.selectedSchemes = {
    //             [id]: value,
    //             los_company_scheme_id: losschemeid
    //         };
    //     }
    //     if(!this.state.selectedSchemes || !this.state.selectedSchemes[id] || this.state.selectedSchemes[id] !== value) {
    //         this.setState({
    //             selectedSchemes: this.selectedSchemes
    //         }, () => {
    //             this.forceUpdate();
    //         });
    //     }
    // }

    // getData = () => {
    //     if(this.props.supplyChains && this.props.supplyChains.size) {
    //         return this.props.supplyChains.map(_ => {
    //             let row = _;
    //             let schemeValue = _.scheme;
    //             if(this.selectedSchemes && this.selectedSchemes[_.id]) {
    //                 schemeValue = this.selectedSchemes[_.id];
    //             }
    //             let schemeId = (this.schemeDataNew[_.seller.id] && this.schemeDataNew[_.seller.id].find(_ => _.id === schemeValue)||{}).id;

    //             let losCompanySchemeId = (this.schemeDataNew[_.seller.id] && this.schemeDataNew[_.seller.id].find(_ => _.id === schemeValue)||{}).los_company_scheme_id;

    //             if(schemeId) {                 
    //                 this.updateSchemeData(_.id, schemeId, losCompanySchemeId);
    //             }

    //             const options = List(this.schemeDataNew[_.seller.id]).map(_ => (
    //                 <Option label={_lower(_.name)} key={_.id} value={_.id} losschemeid={_.los_company_scheme_id}>
    //                     {_.name}
    //                 </Option>
    //             ));

    //             row = row.set("scheme", (
    //                 <Select
    //                     value={schemeId}
    //                     // valueProp
    //                     onSelect={(val, __) => this.updateSchemeData(_.id, val, __.props.losschemeid)}
    //                     filterOption={(inputVal, option) =>  option.props.label.includes(_lower(inputVal))}
    //                     showSearch={true}
    //                 >
    //                     {options}
    //                 </Select>
    //             ));

    //             const description = (this.schemeDataNew[_.seller.id] && this.schemeDataNew[_.seller.id].find(_ => _.id == schemeId) || {description: "" }).description;
    //             row = row.set("description", description);
    //             return row;
    //         });
    //     }
    //     return new List([]);
    // }

    onModalCancel = () => {
        this.setState({
            confirmationModalShow : false
        });
    }
    onModalConfirm= () => {
        const {selectedSchemes} = this;
        const { form } = this.props;
        this.setState({
            confirmationModalShow : false
        });
        form.validateFields(() => {
            this.props.submitForm({
                // ...values, 
                supply_chains: this.props.supplyChains ? this.props.supplyChains.map(_ => _.set("scheme", selectedSchemes[_.id]).set("los_company_scheme_id", selectedSchemes.los_company_scheme_id)) : new List([])
            });
        });
    }
    shouldUpdateScheme = () => {
        return !Object.keys(this.selectedSchemes).length || (this.props.supplyChains &&this.props.supplyChains.size +1 !== Object.keys(this.selectedSchemes).length) ? true : false;
    }
    render() {
        return (
            <Card
                className={"padless-card"}
                size={"small"}
                title={"Facility Details"}
            >
                <Form
                    onSubmit={this.handleFormSubmit}
                    layout={"vertical"}
                    className={cx("form", "p-10", "br-3")}
                >
                    {/* {this.FORM_FIELDS.map((fields, row) => {
                        return (
                            <div key={row} className="form-row">
                                {fields
                                    .map((field, fieldName) => {
                                        // if(fieldName === "disbursal_account") {
                                        //     field.getOptionsOnFocus = CompanyService.getBankAccounts(this.props.companyId);
                                        // }
                                        // if(fieldName === "collection_account") {
                                        //     field.getOptionsOnFocus = CompanyService.getBankAccounts(this.props.companyId);
                                        // }
                                        if(fieldName === "anchor_relationship_manager") {
                                            field.options = this.props.associates && this.props.associates.size ? this.props.associates.map(_ => ({
                                                name: _.first_name + " " + _.last_name,
                                                id: _.id 
                                            })).toList() : new List([]);
                                        }
                                        return this.fieldGenerator(
                                            fieldName,
                                            field,
                                            this.getValidateStatus(fieldName)
                                        )();
                                    })
                                    .toList()}
                            </div>
                        );
                    }).toList().toArray()} */}
                    <FormItem>
                        <Table 
                            columns={SUPPLY_CHAIN_COLS}
                            data={this.props.supplyChains && this.props.supplyChains.size ? this.props.supplyChains : List()}
                            showFilters={false}
                            showColumnSelector={false}
                            title={"Supply Chains"}
                            onFilter={this.onFilter}
                            noRowSelection={true}
                        />
                    </FormItem>
                    <FormItem>
                        <Button
                            disabled={true}
                            // disabled={this.shouldUpdateScheme()}
                            type={this.props.processingFeeAmountFromCaseDetails === 0 ? "primary" : "secondary"}
                            htmlType="submit" 
                            icon={this.props.processingFeeAmountFromCaseDetails > 0 ? "check" : null}
                        >{this.props.processingFeeAmountFromCaseDetails === 0 ? "Confirm" : "Confirmed"}</Button>
                    </FormItem>
                </Form>
                <ConfirmationActionModal
                    visible={this.state.confirmationModalShow}
                    modalTitle={"Caution!"} 
                    onModalCancel={this.onModalCancel}
                    contentHead={"<div><b>Incorrect scheme selection will lead to wrong agreement and disbursal.</b></div>"}
                    schemeSelectedDetails={this.state.schemeSelectedDetails}
                    onModalConfirm={this.onModalConfirm}
                    modalBottomContent={`<div><b>Please be sure that above scheme is correct. You can't undo this.</b><br>Are you sure, ${this.props.user.first_name}?</div>`}/>
            </Card>
        );
    }
}

AccountFacilityForm.propTypes = {
    submitForm: PropTypes.func,
    form: PropTypes.object,
    associates: PropTypes.object,
    companyId: PropTypes.number,
    values: PropTypes.object,
    supplyChains: PropTypes.object,
    schemes: PropTypes.object,
    bankId: PropTypes.number,
    processingFeeAmountFromCaseDetails: PropTypes.number,
    user : PropTypes.object
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return (
            values &&
            values
                .toSeq()
                .toMap()
                .map((value, key) => {
                    if(key === "sanction_date" || key === "agreement_end_date") {
                        return Form.createFormField({
                            value: value && moment(value)
                        });
                    }
                    return Form.createFormField({
                        value
                    });
                })
                .toJS()
        );
    }
})(AccountFacilityForm);

